<template>
  <div class="row-wrapper">
    <div class="feature-name">
      <div class="name">
        {{ locales(feature.locale) }}
        <tippy placement='right' v-if="checkModal()">
          <template v-slot:trigger>
            <svgImage :name="'pricing-table-modal-icon'"/>
          </template>
 
          <div class="name-lottie" :style="{paddingBottom: '12px'}">{{ locales(feature.locale) }}</div>
          <LottieAdapter :path="`${feature.lottie}`" :maxWidth="300"/>
        </tippy>
      </div>
    </div>
    <div class="plans-access">
      <table-cell v-for="(plan, index) in plans" :key="index" :plan="plan" :feature="feature" />
    </div>
  </div>
</template>

<script>
import tableCell from './tableCell.vue';
import svgImage from '../../common/VueComponents/VueIcon/vgpSvgImage.vue';
import LottieAdapter from '../../tooltip/LottieAdapter.vue';

export default {
  components: { tableCell, svgImage, LottieAdapter },
  props: [
    'plans',
    'feature',
  ],
  data() {
    return {
      locales: __,
    };
  },

  methods: {
    checkModal() {
      return this.feature.modal ? true : false;
    },
  }
};
</script>

<style scoped src="../less/paymentPlans.less"></style>
